const PRODUCT_SIZE_HEADER_PATTERN = /^(?:product size|taille du produit)$/i;
const RECOMMENDED_AGE_HEADER_PATTERN = /(?:recommended age|target age|approx\.? age|approx\.? us equivalent|us size \/ recommended age|âge recommandé|âge cible|âge approximatif|équivalent us approximatif|edad recomendada|edad objetivo)/i;
const NON_MEASUREMENT_HEADER_PATTERN = /^(?:product size|standard size|us size|approx\.? us equivalent|us size \/ recommended age|recommended age|target age|approx\.? age|age|years?|ans|size|taille du produit|taille standard|équivalent us approximatif|âge recommandé|âge approximatif)$/i;
const MEASUREMENT_HEADER_PATTERN = /(?:\bbust\b|\bchest\b|\bwaist(?:line)?\b|\bhips?\b|\bbuttocks?\b|\belasticity\b|\bshoulder(?: width)?\b|\bheight\b|\blength\b|\blenght\b|\bskirt long\b|\blong skirt\b|\btop\b|\bsleeves?(?: length)?\b|\bpants?\b|\btrousers?\b|\bcuff\b|\bwidth\b|\bneck\b|\bcollar\b|\barm(?:hole)?\b|\bbiceps?\b|\bthigh\b|\bleg\b|\binseam\b|\boutseam\b|\brise\b|\bcalf\b|poitrine|tour de poitrine|\bbuste\b|^taille$|hanches?|fessier|élasticité|elasticidad|épaules?|largeur|hauteur|longueur|manches?|mangas?|pantalon|cou|col|bras|emmanchure|biceps?|cuisse|jambe|poignet|entrejambe|cheville|mollet)/i;
const HEADER_UNIT_PATTERN = /\s*(?:\((?:cm|centimeters?|centimetres?|centimètres?|in|inches?|pouces?|pulgadas?|zoll|pollici)\)|\b(?:cm|inches?|pouces?|pulgadas?|zoll|pollici)\b)\s*$/i;
const INCH_HEADER_PATTERN = /(?:\b(?:in|inches?|pouces?|pulgadas?|zoll|pollici)\b)\s*\)?\s*$/i;
const CENTIMETER_HEADER_PATTERN = /(?:\b(?:cm|centimeters?|centimetres?|centimètres?)\b)\s*\)?\s*$/i;
const LOCALE_CODE = document.documentElement.lang.toLowerCase().split(/[-_]/)[0];

const APPAREL_SIZE_ALIASES = {
  TTP: 'XXS',
  'T/T/P': 'XXS',
  XXS: 'XXS',
  '2XS': 'XXS',
  TP: 'XS',
  'T/P': 'XS',
  XS: 'XS',
  S: 'S',
  M: 'M',
  L: 'L',
  TG: 'XL',
  'T/G': 'XL',
  XL: 'XL',
  TTG: '2XL',
  '2TG': '2XL',
  XXL: '2XL',
  '2XL': '2XL',
  TTTG: '3XL',
  '3TG': '3XL',
  XXXL: '3XL',
  '3XL': '3XL',
  '4TG': '4XL',
  XXXXL: '4XL',
  '4XL': '4XL',
  '5TG': '5XL',
  XXXXXL: '5XL',
  '5XL': '5XL',
  '6TG': '6XL',
  XXXXXXL: '6XL',
  '6XL': '6XL',
};

const AGE_BY_PRODUCT_SIZE = {
  '2T': { en: '12–18 Months', fr: '12–18 mois', es: '12–18 meses', de: '12–18 Monate', it: '12–18 mesi' },
  '4T': { en: '2–3 Years', fr: '2–3 ans', es: '2–3 años', de: '2–3 Jahre', it: '2–3 anni' },
  '6T': { en: '4–5 Years', fr: '4–5 ans', es: '4–5 años', de: '4–5 Jahre', it: '4–5 anni' },
  '8T': { en: '6–7 Years', fr: '6–7 ans', es: '6–7 años', de: '6–7 Jahre', it: '6–7 anni' },
  '10T': { en: '8–10 Years', fr: '8–10 ans', es: '8–10 años', de: '8–10 Jahre', it: '8–10 anni' },
};

const HEADER_TRANSLATIONS = {
  fr: {
    'Product Size': 'Taille du produit', 'Standard Size': 'Taille standard', 'US Size': 'Taille US',
    'Recommended Age': 'Âge recommandé', 'Child Height': 'Taille de l’enfant',
    'Recommended Child Height': 'Taille recommandée de l’enfant', 'Max Child Height': 'Taille maximale de l’enfant',
    'Child Height Min': 'Taille minimale de l’enfant', 'Child Height Max': 'Taille maximale de l’enfant',
    'Recommended Height': 'Taille recommandée', 'Max Height': 'Taille maximale', 'For Height': 'Pour une taille de',
    Height: 'Taille', Bust: 'Tour de poitrine', 'Bust Min': 'Poitrine min.', 'Bust Max': 'Poitrine max.',
    Chest: 'Poitrine', Waist: 'Tour de taille', 'Waist Min': 'Taille min.', 'Waist Max': 'Taille max.',
    Hips: 'Hanches', 'Hip Circumference': 'Tour de hanches',
    'Waist Circumference': 'Tour de taille', Elasticity: 'Élasticité', Shoulder: 'Épaule', 'Shoulder Width': 'Largeur d’épaule',
    'Dress Length': 'Longueur de la robe', 'Clothes Length': 'Longueur du vêtement', 'Top Length': 'Longueur du haut',
    'Skirt Length': 'Longueur de la jupe', 'Pants Waist': 'Tour de taille du pantalon', 'Sleeve Length': 'Longueur des manches',
    'Pants Length': 'Longueur du pantalon', 'Top Bust': 'Poitrine du haut', 'Top Waist': 'Tour de taille du haut',
    'Dress Bust': 'Poitrine de la robe', 'Dress Waist': 'Tour de taille de la robe',
    'Trench Length': 'Longueur du trench', 'Trench Bust': 'Tour de poitrine du trench',
    'Shirt Bust': 'Tour de poitrine de la chemise', 'Cape Length': 'Longueur de la cape',
    Length: 'Longueur', 'Length Min': 'Longueur min.',
    'Length Max': 'Longueur max.', Width: 'Largeur', Cuff: 'Poignet',
  },
  es: {
    'Product Size': 'Talla del producto', 'Standard Size': 'Talla estándar', 'US Size': 'Talla de EE. UU.',
    'Recommended Age': 'Edad recomendada', 'Child Height': 'Altura del niño',
    'Recommended Child Height': 'Altura recomendada del niño', 'Max Child Height': 'Altura máxima del niño',
    'Child Height Min': 'Altura mínima del niño', 'Child Height Max': 'Altura máxima del niño',
    'Recommended Height': 'Altura recomendada', 'Max Height': 'Altura máxima', 'For Height': 'Para una altura de',
    Height: 'Altura', Bust: 'Busto', 'Bust Min': 'Busto mín.', 'Bust Max': 'Busto máx.', Chest: 'Pecho',
    Waist: 'Cintura', 'Waist Min': 'Cintura mín.', 'Waist Max': 'Cintura máx.', Hips: 'Caderas',
    'Hip Circumference': 'Contorno de cadera', 'Waist Circumference': 'Contorno de cintura', Elasticity: 'Elasticidad',
    Shoulder: 'Hombro', 'Shoulder Width': 'Ancho de hombros', 'Dress Length': 'Largo del vestido',
    'Clothes Length': 'Largo de la prenda', 'Top Length': 'Largo de la parte superior',
    'Skirt Length': 'Largo de la falda', 'Pants Waist': 'Cintura del pantalón', 'Sleeve Length': 'Largo de mangas',
    'Pants Length': 'Largo del pantalón', 'Top Bust': 'Busto de la parte superior',
    'Top Waist': 'Cintura de la parte superior', 'Dress Bust': 'Busto del vestido',
    'Dress Waist': 'Cintura del vestido', 'Trench Length': 'Largo de la gabardina',
    'Trench Bust': 'Busto de la gabardina', 'Shirt Bust': 'Busto de la camisa',
    'Cape Length': 'Largo de la capa', Length: 'Largo', 'Length Min': 'Largo mín.',
    'Length Max': 'Largo máx.', Width: 'Ancho', Cuff: 'Puño',
  },
  de: {
    'Product Size': 'Produktgröße', 'Standard Size': 'Standardgröße', 'US Size': 'US-Größe',
    'Recommended Age': 'Empfohlenes Alter', 'Child Height': 'Körpergröße des Kindes',
    'Recommended Child Height': 'Empfohlene Körpergröße des Kindes', 'Max Child Height': 'Maximale Körpergröße des Kindes',
    'Child Height Min': 'Minimale Körpergröße des Kindes', 'Child Height Max': 'Maximale Körpergröße des Kindes',
    'Recommended Height': 'Empfohlene Körpergröße', 'Max Height': 'Maximale Körpergröße', 'For Height': 'Für Körpergröße',
    Height: 'Körpergröße', Bust: 'Brustumfang', 'Bust Min': 'Brustumfang min.', 'Bust Max': 'Brustumfang max.',
    Chest: 'Brust', Waist: 'Taillenumfang', 'Waist Min': 'Taillenumfang min.', 'Waist Max': 'Taillenumfang max.', Hips: 'Hüfte', 'Hip Circumference': 'Hüftumfang', 'Waist Circumference': 'Taillenumfang', Elasticity: 'Elastizität',
    Shoulder: 'Schulter', 'Shoulder Width': 'Schulterbreite', 'Dress Length': 'Kleiderlänge',
    'Clothes Length': 'Kleidungslänge', 'Top Length': 'Oberteillänge', 'Skirt Length': 'Rocklänge',
    'Pants Waist': 'Hosenbundweite', 'Sleeve Length': 'Ärmellänge', 'Pants Length': 'Hosenlänge',
    'Top Bust': 'Brustumfang des Oberteils', 'Top Waist': 'Taillenumfang des Oberteils',
    'Dress Bust': 'Brustumfang des Kleides', 'Dress Waist': 'Taillenumfang des Kleides',
    'Trench Length': 'Trenchcoat-Länge', 'Trench Bust': 'Brustumfang des Trenchcoats',
    'Shirt Bust': 'Brustumfang des Hemdes', 'Cape Length': 'Cape-Länge', Length: 'Länge',
    'Length Min': 'Länge min.', 'Length Max': 'Länge max.', Width: 'Breite', Cuff: 'Manschette',
  },
  it: {
    'Product Size': 'Taglia del prodotto', 'Standard Size': 'Taglia standard', 'US Size': 'Taglia USA',
    'Recommended Age': 'Età consigliata', 'Child Height': 'Altezza del bambino',
    'Recommended Child Height': 'Altezza consigliata del bambino', 'Max Child Height': 'Altezza massima del bambino',
    'Child Height Min': 'Altezza minima del bambino', 'Child Height Max': 'Altezza massima del bambino',
    'Recommended Height': 'Altezza consigliata', 'Max Height': 'Altezza massima', 'For Height': 'Per un’altezza di',
    Height: 'Altezza', Bust: 'Busto', 'Bust Min': 'Busto min.', 'Bust Max': 'Busto max.', Chest: 'Torace',
    Waist: 'Circonferenza vita', 'Waist Min': 'Circonferenza vita min.', 'Waist Max': 'Circonferenza vita max.',
    Hips: 'Fianchi', 'Hip Circumference': 'Circonferenza fianchi', 'Waist Circumference': 'Circonferenza vita',
    Elasticity: 'Elasticità', Shoulder: 'Spalla',
    'Shoulder Width': 'Larghezza spalle', 'Dress Length': 'Lunghezza vestito',
    'Clothes Length': 'Lunghezza capo', 'Top Length': 'Lunghezza parte superiore',
    'Skirt Length': 'Lunghezza gonna', 'Pants Waist': 'Circonferenza vita dei pantaloni',
    'Sleeve Length': 'Lunghezza manica', 'Pants Length': 'Lunghezza pantaloni',
    'Top Bust': 'Circonferenza seno del top', 'Top Waist': 'Circonferenza vita del top',
    'Dress Bust': 'Circonferenza seno del vestito', 'Dress Waist': 'Circonferenza vita del vestito',
    'Trench Length': 'Lunghezza del trench', 'Trench Bust': 'Circonferenza seno del trench',
    'Shirt Bust': 'Circonferenza seno della camicia', 'Cape Length': 'Lunghezza della mantella',
    Length: 'Lunghezza', 'Length Min': 'Lunghezza min.',
    'Length Max': 'Lunghezza max.', Width: 'Larghezza', Cuff: 'Polsino',
  },
};

const HEADER_ALIASES = [
  [/^(?:product size|taille du produit)$/i, 'Product Size', 'Taille du produit'],
  [/^(?:standard size|taille standard)$/i, 'Standard Size', 'Taille standard'],
  [/^(?:us size|taille us)$/i, 'US Size', 'Taille US'],
  [/^(?:recommended age|target age|approx\.? age|approx\.? us equivalent|us size \/ recommended age|âge recommandé|âge cible|âge approximatif|équivalent us approximatif|edad recomendada|edad objetivo)$/i, 'Recommended Age', 'Âge recommandé'],
  [/^(?:child height|taille de l[’']enfant)$/i, 'Child Height', 'Taille de l’enfant'],
  [/^(?:recommended child height|taille recommandée de l[’']enfant|taille de l[’']enfant recommandée|pour la taille|para altura)$/i, 'Recommended Child Height', 'Taille recommandée de l’enfant'],
  [/^(?:max child height|maximum child height|hauteur maximale de l[’']enfant|taille maximale de l[’']enfant)$/i, 'Max Child Height', 'Taille maximale de l’enfant'],
  [/^(?:child height min|taille minimale de l[’']enfant)$/i, 'Child Height Min', 'Taille minimale de l’enfant'],
  [/^(?:child height max|taille maximale de l[’']enfant)$/i, 'Child Height Max', 'Taille maximale de l’enfant'],
  [/^(?:recommended height|suitable height|corresponding height|appropriate height|suggested height|target height|hauteur recommandée)$/i, 'Recommended Height', 'Taille recommandée'],
  [/^(?:max height|hauteur maximale|altura máx\.?|altezza max\.?|maximale höhe)$/i, 'Max Height', 'Taille maximale'],
  [/^(?:for height|pour une taille de)$/i, 'For Height', 'Pour une taille de'],
  [/^height$/i, 'Height', 'Taille'],
  [/^(?:bust|tour de poitrine|poitrine)$/i, 'Bust', 'Tour de poitrine'],
  [/^(?:bust min|poitrine min\.?)$/i, 'Bust Min', 'Poitrine min.'],
  [/^(?:bust max|poitrine max\.?)$/i, 'Bust Max', 'Poitrine max.'],
  [/^chest$/i, 'Chest', 'Poitrine'],
  [/^pants waist$/i, 'Pants Waist', 'Tour de taille du pantalon'],
  [/^(?:waist|waistline|tour de taille)$/i, 'Waist', 'Tour de taille'],
  [/^waist circumference$/i, 'Waist Circumference', 'Tour de taille'],
  [/^(?:waist min|taille min\.?)$/i, 'Waist Min', 'Taille min.'],
  [/^(?:waist max|taille max\.?)$/i, 'Waist Max', 'Taille max.'],
  [/^(?:hips?|hanches?)$/i, 'Hips', 'Hanches'],
  [/^circumference \(hips\)$/i, 'Hip Circumference', 'Tour de hanches'],
  [/^(?:buttocks?|fessier|glúteos?)$/i, 'Hips', 'Hanches'],
  [/^(?:elasticity|élasticité|elasticidad|elastizität|elasticità)$/i, 'Elasticity', 'Élasticité'],
  [/^(?:shoulder|épaule)$/i, 'Shoulder', 'Épaule'],
  [/^(?:shoulder width|largeur d[’']épaule)$/i, 'Shoulder Width', 'Largeur d’épaule'],
  [/^(?:dress lengt(?:h)?|longueur de la robe)$/i, 'Dress Length', 'Longueur de la robe'],
  [/^dress bust$/i, 'Dress Bust', 'Poitrine de la robe'],
  [/^dress waist$/i, 'Dress Waist', 'Tour de taille de la robe'],
  [/^(?:clothes length|clothing length|longueur du vêtement)$/i, 'Clothes Length', 'Longueur du vêtement'],
  [/^(?:top|top length|longueur du haut)$/i, 'Top Length', 'Longueur du haut'],
  [/^top bust$/i, 'Top Bust', 'Poitrine du haut'],
  [/^top waist$/i, 'Top Waist', 'Tour de taille du haut'],
  [/^(?:skirt length|skirt long|long skirt|longueur de la jupe)$/i, 'Skirt Length', 'Longueur de la jupe'],
  [/^(?:sleeves?|sleeve length|longueur des manches?|largo de mangas?)$/i, 'Sleeve Length', 'Longueur des manches'],
  [/^trench length$/i, 'Trench Length', 'Longueur du trench'],
  [/^trench bust$/i, 'Trench Bust', 'Tour de poitrine du trench'],
  [/^shirt bust$/i, 'Shirt Bust', 'Tour de poitrine de la chemise'],
  [/^cape length$/i, 'Cape Length', 'Longueur de la cape'],
  [/^(?:pant length|pants length|trousers length|longueur du pantalon)$/i, 'Pants Length', 'Longueur du pantalon'],
  [/^(?:length|lenght|longueur)$/i, 'Length', 'Longueur'],
  [/^(?:length min|longueur min\.?)$/i, 'Length Min', 'Longueur min.'],
  [/^(?:length max|longueur max\.?)$/i, 'Length Max', 'Longueur max.'],
  [/^(?:width|largeur)$/i, 'Width', 'Largeur'],
  [/^(?:cuff|poignet)$/i, 'Cuff', 'Poignet'],
];

function normalizeText(value) {
  return value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
}

function canonicalizeApparelSize(value) {
  const normalized = normalizeText(value).toUpperCase().replace(/[.\s-]/g, '');
  return APPAREL_SIZE_ALIASES[normalized] || value;
}

function normalizeApparelSizeColumns(modal) {
  modal.querySelectorAll('.size-guide-table-scroll table').forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th'));
    const sizeColumnIndexes = headers
      .map((header, index) => ({ index, label: getEnglishHeader(header.textContent) }))
      .filter(({ label }) => ['Product Size', 'Standard Size', 'US Size'].includes(label))
      .map(({ index }) => index);

    table.querySelectorAll('tbody tr').forEach((row) => {
      sizeColumnIndexes.forEach((index) => {
        const cell = row.cells[index];
        if (cell) cell.textContent = canonicalizeApparelSize(cell.textContent);
      });
    });
  });
}

function parseNumbers(rawValue, unit) {
  let normalizedValue = normalizeText(rawValue);
  if (!normalizedValue) return null;
  normalizedValue = unit === 'in'
    ? normalizedValue.replace(/(?:["″]|\bin(?:ches)?\b|\bpouces?\b)/gi, '')
    : normalizedValue.replace(/\b(?:cm|centimeters?|centimetres?|centimètres?)\b/gi, '');

  const parts = normalizedValue.trim().split(/\s*(?:[–—-]|\/)\s*/);
  if (parts.length === 0 || parts.length > 2) return null;
  const values = parts.map((part) => {
    const normalizedPart = part.trim().replace(',', '.');
    const feetAndInches = unit === 'in'
      ? normalizedPart.match(/^(\d+(?:\.\d+)?)\s*(?:['’′]|\b(?:ft|feet)\b)\s*(\d+(?:\.\d+)?)?$/i)
      : null;
    return feetAndInches
      ? Number(feetAndInches[1]) * 12 + Number(feetAndInches[2] || 0)
      : Number(normalizedPart);
  });
  return values.every(Number.isFinite) ? values : null;
}

function parseInches(rawValue, explicitUnit = false) {
  if (!explicitUnit && !/(?:["″'’′]|\bin(?:ches)?\b|\bpouces?\b|\b(?:ft|feet)\b)/i.test(rawValue)) return null;
  return parseNumbers(rawValue, 'in');
}

function parseCentimeters(rawValue) {
  return parseNumbers(rawValue, 'cm');
}

function formatNumber(value, decimals = 1) {
  return String(Number(value.toFixed(decimals)));
}

function formatCentimeters(values) {
  return `${values.map((value) => formatNumber(value)).join('–')} cm`;
}

function formatInches(values) {
  return values.map((value) => `${formatNumber(value)}"`).join('–');
}

function centimetersToInches(values) {
  return values.map((value) => Number((value / 2.54).toFixed(1)));
}

function inchesToCentimeters(values) {
  return values.map((value) => {
    const centimeters = value * 2.54;
    const nearestInteger = Math.round(centimeters);
    return Math.abs(centimeters - nearestInteger) < 0.25 ? nearestInteger : Number(centimeters.toFixed(1));
  });
}

function getHeaderBaseLabel(label) {
  return normalizeText(label).replace(HEADER_UNIT_PATTERN, '').trim();
}

function getHeaderAlias(label) {
  const baseLabel = getHeaderBaseLabel(label);
  const explicitAlias = HEADER_ALIASES.find(([pattern]) => pattern.test(baseLabel));
  if (explicitAlias) return explicitAlias;

  for (const translations of Object.values(HEADER_TRANSLATIONS)) {
    const localizedEntry = Object.entries(translations).find(([, localizedLabel]) => (
      normalizeText(localizedLabel).localeCompare(normalizeText(baseLabel), undefined, { sensitivity: 'base' }) === 0
    ));
    if (localizedEntry) {
      const [englishLabel] = localizedEntry;
      return [null, englishLabel, HEADER_TRANSLATIONS.fr[englishLabel] || englishLabel];
    }
  }

  return [null, baseLabel, baseLabel];
}

function getEnglishHeader(label) {
  return getHeaderAlias(label)[1];
}

function getLocalizedHeader(label) {
  const englishLabel = getEnglishHeader(label);
  return HEADER_TRANSLATIONS[LOCALE_CODE]?.[englishLabel] || englishLabel;
}

function getMeasurementKey(label) {
  return getEnglishHeader(label).toLowerCase();
}

function isMeasurementHeader(headerText) {
  const normalizedHeader = getEnglishHeader(headerText);
  return !NON_MEASUREMENT_HEADER_PATTERN.test(normalizedHeader) && MEASUREMENT_HEADER_PATTERN.test(normalizedHeader);
}

function getHeaderSourceUnit(label) {
  if (INCH_HEADER_PATTERN.test(label)) return 'in';
  if (CENTIMETER_HEADER_PATTERN.test(label)) return 'cm';
  return null;
}

function readCanonicalSource(cell, sourceUnit) {
  const sourceValue = cell.dataset.measurementSourceValue || cell.dataset.cm || cell.textContent;
  if (!cell.dataset.measurementSourceValue) cell.dataset.measurementSourceValue = normalizeText(sourceValue);
  const rememberedUnit = cell.dataset.measurementSourceUnit;
  const canonicalUnit = rememberedUnit || sourceUnit || (parseInches(sourceValue) ? 'in' : 'cm');
  if (!rememberedUnit) cell.dataset.measurementSourceUnit = canonicalUnit;
  const values = canonicalUnit === 'in'
    ? parseInches(cell.dataset.measurementSourceValue, true)
    : parseCentimeters(cell.dataset.measurementSourceValue);
  return values ? { unit: canonicalUnit, values } : null;
}

function normalizeHeaders(table) {
  Array.from(table.querySelectorAll('thead th')).forEach((header) => {
    if (!header.dataset.measurementOriginalHeader) {
      header.dataset.measurementOriginalHeader = normalizeText(header.textContent);
    }
    header.textContent = getLocalizedHeader(header.dataset.measurementOriginalHeader);
  });
}

function getCanonicalKidsColumnOrder(headers) {
  const labels = headers.map((header) => getEnglishHeader(header.dataset.measurementOriginalHeader || header.textContent));
  const productSizeIndex = labels.findIndex((label) => label === 'Product Size');
  const recommendedAgeIndex = labels.findIndex((label) => label === 'Recommended Age');
  const recommendedHeightIndex = labels.findIndex((label) => [
    'Recommended Child Height',
    'Child Height',
    'Recommended Height',
    'For Height',
    'Height',
  ].includes(label));
  const dressLengthIndex = labels.findIndex((label) => ['Dress Length', 'Length'].includes(label));
  const coreIndexes = [productSizeIndex, recommendedAgeIndex, recommendedHeightIndex, dressLengthIndex];
  if (coreIndexes.some((index) => index === -1) || new Set(coreIndexes).size !== coreIndexes.length) return null;

  headers[productSizeIndex].dataset.measurementOriginalHeader = 'Product Size';
  headers[recommendedAgeIndex].dataset.measurementOriginalHeader = 'Recommended Age';
  headers[recommendedHeightIndex].dataset.measurementOriginalHeader = 'Recommended Child Height';
  headers[dressLengthIndex].dataset.measurementOriginalHeader = 'Dress Length';

  return [
    ...coreIndexes,
    ...headers.map((_, index) => index).filter((index) => !coreIndexes.includes(index)),
  ];
}

function normalizeSizeGuideColumnOrder(modal) {
  modal.querySelectorAll('.size-guide-table-scroll table').forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th'));
    const order = getCanonicalKidsColumnOrder(headers);
    const headerRow = table.querySelector('thead tr');
    if (!order || !headerRow) return;

    order.forEach((index) => headerRow.appendChild(headers[index]));
    table.querySelectorAll('tbody tr').forEach((row) => {
      const cells = Array.from(row.cells);
      order.forEach((index) => {
        if (cells[index]) row.appendChild(cells[index]);
      });
    });
  });
}

function updateMeasurementColumns(modal, unit) {
  modal.querySelectorAll('.size-guide-table-scroll table').forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th'));
    const groups = new Map();
    headers.forEach((header, index) => {
      const originalLabel = header.dataset.measurementOriginalHeader || normalizeText(header.textContent);
      const hasExplicitUnit = Array.from(table.querySelectorAll('tbody tr')).some((row) => {
        const cell = row.cells[index];
        const sourceValue = cell?.dataset.measurementSourceValue || cell?.textContent || '';
        return /["″]|\b(?:cm|inches?|pouces?|pulgadas?|zoll|pollici)\b/i.test(sourceValue);
      });
      if (!isMeasurementHeader(originalLabel) && !hasExplicitUnit) return;
      const key = getMeasurementKey(originalLabel);
      const columns = groups.get(key) || [];
      columns.push({ index, header, sourceUnit: getHeaderSourceUnit(originalLabel) });
      groups.set(key, columns);
    });

    groups.forEach((columns) => {
      const primary = columns[0];
      primary.header.style.display = '';
      columns.slice(1).forEach(({ header }) => { header.style.display = 'none'; });
      table.querySelectorAll('tbody tr').forEach((row) => {
        const primaryCell = row.cells[primary.index];
        if (!primaryCell) return;
        let centimeterValues = parseCentimeters(primaryCell.dataset.measurementCanonicalCm || '');
        let inchValues = parseCentimeters(primaryCell.dataset.measurementCanonicalIn || '');

        columns.forEach(({ index, sourceUnit }, position) => {
          const cell = row.cells[index];
          if (!cell) return;
          cell.style.display = position === 0 ? '' : 'none';
          const source = readCanonicalSource(cell, sourceUnit);
          if (!source) return;
          if (source.unit === 'cm' && !centimeterValues) centimeterValues = source.values;
          if (source.unit === 'in' && !inchValues) inchValues = source.values;
        });

        if (centimeterValues) primaryCell.dataset.measurementCanonicalCm = centimeterValues.join('–');
        if (inchValues) primaryCell.dataset.measurementCanonicalIn = inchValues.join('–');
        const displayInches = centimeterValues ? centimetersToInches(centimeterValues) : inchValues;
        const displayCentimeters = centimeterValues || (inchValues && inchesToCentimeters(inchValues));
        if (unit === 'in' && displayInches) {
          const originalInches = normalizeText(primaryCell.dataset.measurementSourceValue || '');
          primaryCell.textContent = !centimeterValues && /^\d+(?:[.,]\d+)?\s*(?:['’′]|\b(?:ft|feet)\b)/i.test(originalInches)
            ? originalInches
            : formatInches(displayInches);
        }
        if (unit === 'cm' && displayCentimeters) primaryCell.textContent = formatCentimeters(displayCentimeters);
      });
    });
    normalizeHeaders(table);
  });
}

function updateRecommendedAgeColumns(modal) {
  const localeKey = AGE_BY_PRODUCT_SIZE['2T'][LOCALE_CODE] ? LOCALE_CODE : 'en';
  modal.querySelectorAll('.size-guide-table-scroll table').forEach((table) => {
    const headers = Array.from(table.querySelectorAll('thead th'));
    const productSizeIndex = headers.findIndex((header) => PRODUCT_SIZE_HEADER_PATTERN.test(getEnglishHeader(header.textContent)));
    const recommendedAgeIndex = headers.findIndex((header) => RECOMMENDED_AGE_HEADER_PATTERN.test(getEnglishHeader(header.textContent)));
    if (productSizeIndex === -1 || recommendedAgeIndex === -1) return;
    table.querySelectorAll('tbody tr').forEach((row) => {
      const size = row.cells[productSizeIndex]?.textContent.trim().toUpperCase();
      const ageCell = row.cells[recommendedAgeIndex];
      if (ageCell && AGE_BY_PRODUCT_SIZE[size]) ageCell.textContent = AGE_BY_PRODUCT_SIZE[size][localeKey];
    });
  });
}

function localizeAgeCells(modal) {
  const ageWord = { fr: 'ans', es: 'años', de: 'Jahre', it: 'anni' }[LOCALE_CODE];
  const monthWord = { de: 'Monate', it: 'mesi' }[LOCALE_CODE] || 'Months';
  if (!ageWord) return;
  modal.querySelectorAll('.size-guide-table-scroll table').forEach((table) => {
    const ageColumnIndexes = Array.from(table.querySelectorAll('thead th'))
      .map((header, index) => ({
        index,
        label: getEnglishHeader(header.dataset.measurementOriginalHeader || header.textContent),
      }))
      .filter(({ label }) => label === 'Product Size' || label === 'Recommended Age')
      .map(({ index }) => index);
    table.querySelectorAll('tbody tr').forEach((row) => {
      ageColumnIndexes.forEach((index) => {
        const cell = row.cells[index];
        if (cell) cell.textContent = cell.textContent
          .replace(/\bYears\b/gi, ageWord)
          .replace(/\bMonths\b/gi, monthWord);
      });
    });
  });
}

function applyUnit(modal, unit) {
  normalizeSizeGuideColumnOrder(modal);
  normalizeApparelSizeColumns(modal);
  updateMeasurementColumns(modal, unit);
  updateRecommendedAgeColumns(modal);
  localizeAgeCells(modal);
  modal.querySelectorAll('.size-unit-btn').forEach((button) => {
    const active = button.dataset.unit === unit;
    button.style.background = active ? '#222' : '#fff';
    button.style.color = active ? '#fff' : '#222';
    button.style.borderColor = active ? '#222' : '#d5d5d5';
  });
}

function initializeSizeGuides() {
  document.querySelectorAll('[id^="size-guide-"]').forEach((modal) => {
    const unit = LOCALE_CODE === 'en' ? 'in' : 'cm';
    applyUnit(modal, unit);
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.size-unit-btn');
  if (!button) return;
  const modal = button.closest('[id^="size-guide-"]');
  if (modal) applyUnit(modal, button.dataset.unit);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSizeGuides);
} else {
  initializeSizeGuides();
}

export {
  canonicalizeApparelSize,
  centimetersToInches,
  getEnglishHeader,
  getMeasurementKey,
  inchesToCentimeters,
  isMeasurementHeader,
  localizeAgeCells,
  normalizeSizeGuideColumnOrder,
  parseCentimeters,
  parseInches,
  updateMeasurementColumns,
};
